export default {
  pendingJobsExportCacheKey: 'pendingExportJobs-',
  pendingExportJobsChecked: false,
  exportJobs: [],
  exportJobsStatus: [],
  intervalStatusJobsHandler: [],
  activeToastId: null
};